import {Component, computed, inject} from '@angular/core';
import {LayoutService} from '@/layout/service/layout.service';

@Component({
    selector: '[app-footer]',
    standalone: true,
    template: `
        <div class="layout-footer">
                <img  src="assets/layout/images/jornada-digital-1.png" alt="jornadaDigitalLogo" width="80px" />

            <span class="footer-copyright">&#169; MaxProcess 2025. Solução Jornada Digital. Todos os direitos reservados.</span>
        </div>
    `
})
export class AppFooter {
    layoutService = inject(LayoutService);

    isDarkTheme = computed(() => this.layoutService.isDarkTheme());
}
